import type {ReactNode} from 'react'
import {Popover} from '@freckle/educator-materials/ts/components/popover'
import {premiumPopoverStyle} from './new-premium-popover.module.scss'

type Props = {
  id: string
  children: ReactNode
  dataTest?: string
  title?: string
}

export function PremiumPopover(props: Props) {
  return (
    <Popover
      id={props.id}
      // eslint-disable-next-line i18next/no-literal-string
      title={props.title ?? 'Premium Only'}
      className={premiumPopoverStyle}
      dataTest={props.dataTest}
    >
      {props.children}
    </Popover>
  )
}
